import { Box, Chip, Stack } from "@mui/material";
import { Custom } from "components";
import { useApp, useTheme } from "contexts";
import { Combines } from "helpers";
import { ICategoryResponse } from "interfaces";

type Props = {
  open: boolean;
  name: string;
  responses: ICategoryResponse[];
  onClose: () => void;
};

export const ViewResponse = ({ name, open, responses, onClose }: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();

  return (
    responses.length > 0 && (
      <Custom.Modal open={open} onClose={onClose} title={name}>
        <Box>
          <Stack spacing={theme.spacing.md}>
            <Custom.Typography
              align="center"
              size={theme.font.sm}
              weight={theme.font.medium}
            >
              {Combines.interpolate(t.message.responses, {
                count: responses.length,
              })}
            </Custom.Typography>
          </Stack>
          <Stack direction="row" mt={theme.spacing.md} gap={theme.spacing.sm}>
            {responses.map(({ user, vote }: ICategoryResponse) => {
              return (
                <Chip
                  key={user._id}
                  avatar={
                    <Custom.Avatar
                      size="small"
                      src={user._id}
                      alt={user.full_name}
                    />
                  }
                  label={user.full_name}
                />
              );
            })}
          </Stack>
        </Box>
      </Custom.Modal>
    )
  );
};
